<template>
  <div class="col-span-2">
    <div class="mt-6 flex items-center flex-wrap">
      <calculator-selected-feature v-for="feature of features" :key="feature.key" :text="feature.text"/>
    </div>
  </div>
</template>

<script>
import CalculatorSelectedFeature from "@/components/calculator-steps/calculator-end/CalculatorSelectedFeature";

export default {
  name: "CalculatorSelectedFeatures",
  components: {
    CalculatorSelectedFeature
  },
  computed: {
    features: function () {
      return this.$store.getters['prices/GET_FEATURES']
    }
  }
}
</script>

<style scoped>

</style>
